export default __webpack_public_path__ + "static/data_consumer_insights-2e6054b200b36f0e6d1a4aad7ac1894e.gif";